import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18Timersolid = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M9 3.375c3.59 0 6.5 2.938 6.5 6.563S12.59 16.5 9 16.5s-6.5-2.938-6.5-6.563S5.41 3.375 9 3.375m0 2.82a.7.7 0 0 0-.696.703v2.994l.007.1a.7.7 0 0 0 .303.485l2.4 1.616.09.051a.69.69 0 0 0 .876-.246l.05-.09a.706.706 0 0 0-.243-.885l-2.09-1.407V6.898l-.007-.096A.7.7 0 0 0 9 6.195"
      }), /*#__PURE__*/jsx("rect", {
        width: 5.571,
        height: 1.406,
        x: 6.214,
        y: 1.5,
        rx: 0.696
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Timersolid$1 = Svg18Timersolid;

export { Svg18Timersolid$1 as default };
